const maintenancesStatusLabel = {
  title: 'In progress',
  title1: 'Canceled',
  title2: 'Completed',
  title3: 'Scheduled',
  title4: 'Pending',
  title5: 'Overdue',
  title6: 'Expired',
};

export default maintenancesStatusLabel;